export default __webpack_public_path__ + "static/media/CookiesRedVelvet.564ee60d.png";